// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectMediaCategotryEdit {
   cursor: pointer;
   width: 100%;
   border: 1px dashed #ced4da;
   border-radius: 15px;
   background-color: rgb(248 248 248);
   padding-left: 40%;
   padding-top: 30px;
}

.selectinputfileCategoryEdit {
   opacity: 0;
   width: 100%;
   cursor: pointer;
}

.product_search_icon i {
   font-size: 14px;
}

.searchList {
   background: #f8f9fa;
   border: 1px solid #dee2e6;
   border-radius: 4px;
   padding: 10px;
   margin-bottom: 8px;
   display: flex;
   justify-content: space-between;
   align-items: center;
   cursor: move;
   transition: background-color 0.2s ease;
}

.searchList:hover {
   background-color: #e9ecef;
}

.removeProduct {
   cursor: pointer;
   color: #dc3545;
   font-size: 18px;
}

.mdi-drag {
   cursor: grab;
}

.mdi-drag:active {
   cursor: grabbing;
}`, "",{"version":3,"sources":["webpack://./src/Components/Category/CategoryEdit/CategoryEdit.css"],"names":[],"mappings":"AAAA;GACG,eAAe;GACf,WAAW;GACX,0BAA0B;GAC1B,mBAAmB;GACnB,kCAAkC;GAClC,iBAAiB;GACjB,iBAAiB;AACpB;;AAEA;GACG,UAAU;GACV,WAAW;GACX,eAAe;AAClB;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,mBAAmB;GACnB,yBAAyB;GACzB,kBAAkB;GAClB,aAAa;GACb,kBAAkB;GAClB,aAAa;GACb,8BAA8B;GAC9B,mBAAmB;GACnB,YAAY;GACZ,sCAAsC;AACzC;;AAEA;GACG,yBAAyB;AAC5B;;AAEA;GACG,eAAe;GACf,cAAc;GACd,eAAe;AAClB;;AAEA;GACG,YAAY;AACf;;AAEA;GACG,gBAAgB;AACnB","sourcesContent":[".selectMediaCategotryEdit {\n   cursor: pointer;\n   width: 100%;\n   border: 1px dashed #ced4da;\n   border-radius: 15px;\n   background-color: rgb(248 248 248);\n   padding-left: 40%;\n   padding-top: 30px;\n}\n\n.selectinputfileCategoryEdit {\n   opacity: 0;\n   width: 100%;\n   cursor: pointer;\n}\n\n.product_search_icon i {\n   font-size: 14px;\n}\n\n.searchList {\n   background: #f8f9fa;\n   border: 1px solid #dee2e6;\n   border-radius: 4px;\n   padding: 10px;\n   margin-bottom: 8px;\n   display: flex;\n   justify-content: space-between;\n   align-items: center;\n   cursor: move;\n   transition: background-color 0.2s ease;\n}\n\n.searchList:hover {\n   background-color: #e9ecef;\n}\n\n.removeProduct {\n   cursor: pointer;\n   color: #dc3545;\n   font-size: 18px;\n}\n\n.mdi-drag {\n   cursor: grab;\n}\n\n.mdi-drag:active {\n   cursor: grabbing;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
